import axios from 'axios';

import { formPortalId } from '@/environment';
import { logger } from '@/services/logger';

interface IRegistrationFormData {
    email: string;
}
export async function submitForm(formGuid: string, { email }: IRegistrationFormData, events: { eventName: string; eventValue: any }[]) {
    try {
        const eventsDataPaylod = events.map(value => ({
            objectTypeId: '0-1',
            name: value.eventName,
            value: value.eventValue ?? 'unknown',
        }));
        await axios.post(`https://api.hsforms.com/submissions/v3/integration/submit/${formPortalId}/${formGuid}`, {
            submittedAt: Date.now(),
            fields: [
                {
                    objectTypeId: '0-1',
                    name: 'email',
                    value: email,
                },
                ...eventsDataPaylod,
            ],
        });
    } catch (error: any) {
        logger.error('could not submit form to hubspot', {
            error,
            status: error.response?.status,
            data: error.response?.data,
            errors: JSON.stringify(error.response?.data?.errors),
        });
    }
}
